var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_276_11432",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_276_11432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 5.375V6.5C5.625 6.60642 5.66092 6.6955 5.73275 6.76725C5.8045 6.83908 5.89358 6.875 6 6.875C6.10642 6.875 6.1955 6.83908 6.26725 6.76725C6.33908 6.6955 6.375 6.60642 6.375 6.5V5.375H7.5C7.60642 5.375 7.6955 5.33908 7.76725 5.26725C7.83908 5.1955 7.875 5.10642 7.875 5C7.875 4.89358 7.83908 4.8045 7.76725 4.73275C7.6955 4.66092 7.60642 4.625 7.5 4.625H6.375V3.5C6.375 3.39358 6.33908 3.3045 6.26725 3.23275C6.1955 3.16092 6.10642 3.125 6 3.125C5.89358 3.125 5.8045 3.16092 5.73275 3.23275C5.66092 3.3045 5.625 3.39358 5.625 3.5V4.625H4.5C4.39358 4.625 4.3045 4.66092 4.23275 4.73275C4.16092 4.8045 4.125 4.89358 4.125 5C4.125 5.10642 4.16092 5.1955 4.23275 5.26725C4.3045 5.33908 4.39358 5.375 4.5 5.375H5.625ZM3.01925 8.75L2.01825 9.75088C1.876 9.89321 1.71238 9.92546 1.52738 9.84762C1.34246 9.76971 1.25 9.62946 1.25 9.42688V2.15387C1.25 1.90129 1.3375 1.6875 1.5125 1.5125C1.6875 1.3375 1.90129 1.25 2.15387 1.25H9.84613C10.0987 1.25 10.3125 1.3375 10.4875 1.5125C10.6625 1.6875 10.75 1.90129 10.75 2.15387V7.84613C10.75 8.09871 10.6625 8.3125 10.4875 8.4875C10.3125 8.6625 10.0987 8.75 9.84613 8.75H3.01925ZM2.7 8H9.84613C9.88463 8 9.91988 7.98396 9.95188 7.95188C9.98396 7.91988 10 7.88462 10 7.84613V2.15387C10 2.11537 9.98396 2.08012 9.95188 2.04812C9.91988 2.01604 9.88463 2 9.84613 2H2.15387C2.11537 2 2.08013 2.01604 2.04813 2.04812C2.01604 2.08012 2 2.11537 2 2.15387V8.69238L2.7 8Z",
    fill: "#0F2E59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.0ba65a58259f9f7a87363c1acc0db3d1.svg";
export { ForwardRef as ReactComponent };